import { TableContainer, Paper, Table, TableHead, TableRow, TableCell, TableBody } from '@mui/material';
import { useContext, useMemo } from 'react'
import AccordionPanel from 'view/FrontEnd/Project/components/AccordionPanel';
import { ProviderExpensePlan } from './FundExpensesPlanForm';
import _ from "lodash";
import { formatNumber } from 'utilities/utilities';

const TableExpenseSummary = (props) => {

    const {
        arrMonth,
        arrMock,
        calIndexOld,
        lstSectionSummary,
        lstSummary,
    } = useContext(ProviderExpensePlan);

    const { keyId } = props;

    const arrTotalSummary = useMemo(() => {
        let lstDataSummary = _.cloneDeep(lstSectionSummary) || [];

        let lstSection4 = lstDataSummary.filter(f => [35, 36, 37, 38].includes(f.nSectionId))
        let lstInputMonthTotal4 = _.cloneDeep(arrMock);
        lstInputMonthTotal4.forEach((eleInput: { nOrder: number; value: any; }) => {
            let sPathValue = `lstExpenseMonth[${eleInput.nOrder - 1}].value`;
            eleInput.value = _.sumBy(lstSection4, (item: any) => _.get(item, sPathValue, 0));
        });

        let obj1 = {
            nSectionId: 98,
            sSectionName: "รวม 40(1-4)",
            nOrder: 98,
            nTotal: _.sumBy(lstSection4, (item: any) => _.get(item, 'nTotal', 0)),
            nQ1: _.sumBy(lstSection4, (item: any) => _.get(item, 'nQ1', 0)),
            nQ2: _.sumBy(lstSection4, (item: any) => _.get(item, 'nQ2', 0)),
            nQ3: _.sumBy(lstSection4, (item: any) => _.get(item, 'nQ3', 0)),
            nQ4: _.sumBy(lstSection4, (item: any) => _.get(item, 'nQ4', 0)),
            lstExpenseMonth: lstInputMonthTotal4
        }

        let lstSection5 = lstDataSummary.filter(f => [35, 36, 37, 38, 39].includes(f.nSectionId))

        let lstInputMonthTotal5 = _.cloneDeep(arrMock);
        lstInputMonthTotal5.forEach((eleInput: { nOrder: number; value: any; }) => {
            let sPathValue = `lstExpenseMonth[${eleInput.nOrder - 1}].value`;
            eleInput.value = _.sumBy(lstSection5, (item: any) => _.get(item, sPathValue, 0));
        });

        let obj2 = {
            nSectionId: 99,
            sSectionName: "รวม 40(1-4) + 40(5)",
            nOrder: 99,
            nTotal: _.sumBy(lstSection5, (item: any) => _.get(item, 'nTotal', 0)),
            nQ1: _.sumBy(lstSection5, (item: any) => _.get(item, 'nQ1', 0)),
            nQ2: _.sumBy(lstSection5, (item: any) => _.get(item, 'nQ2', 0)),
            nQ3: _.sumBy(lstSection5, (item: any) => _.get(item, 'nQ3', 0)),
            nQ4: _.sumBy(lstSection5, (item: any) => _.get(item, 'nQ4', 0)),
            lstExpenseMonth: lstInputMonthTotal5
        }

        lstDataSummary.push(obj1);
        lstDataSummary.push(obj2);

        return lstDataSummary;
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [arrMock, lstSummary])

    return (
        <AccordionPanel header={"ยอดรวมทุกมาตรา"} >
            <TableContainer id='table-pinned' sx={{ maxHeight: "80vh" }} component={Paper}>
                <Table stickyHeader sx={{ minWidth: 1400 }} >
                    <TableHead>
                        <TableRow>
                            <TableCell className="sticky-cell pad-0 head-color" component="th" padding='none' style={{ minWidth: '360px', width: '360px' }}>
                                <TableCell className='cell-in-sticky border-l head-color' component="th" padding='none' style={{ minWidth: '60px', width: '60px' }}>ลำดับที่</TableCell>
                                <TableCell className='cell-in-sticky border-l head-color' component="th" padding='none' style={{ minWidth: '300px', width: '300px' }}>รายการ</TableCell>
                            </TableCell>


                            {
                                arrMonth.map((month, indexM) => {
                                    return (
                                        <TableCell
                                            key={month}
                                            component="th"
                                            padding='none'
                                            sx={{
                                                minWidth: '150px',
                                                width: '150px',
                                                backgroundColor: [3, 7, 11, 15].includes(indexM) ? '#70b603 !important' : ""
                                            }}
                                        >
                                            {month}
                                        </TableCell>
                                    )
                                })
                            }
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {
                            arrTotalSummary.map((itemRow, indexShow) => {
                                let keyCellTable = keyId + itemRow.nSectionId;
                                let isTotal = [98, 99].includes(itemRow.nSectionId);
                                let isHead: "th" | "td" = isTotal ? "th" : "td";
                                return (
                                    <TableRow key={keyCellTable}>
                                        <TableCell className="sticky-cell pad-0" padding='none' sx={{ backgroundColor: isTotal ? "" : "#ffffff !important", zIndex: "2 !important" }}>
                                            <TableCell className='cell-in-sticky border-l' padding='none' component={isHead} align='center' sx={{ minWidth: '60px', width: '60px', backgroundColor: isTotal ? "" : "#ffffff !important" }}>{isTotal ? "" : indexShow + 1}</TableCell>
                                            <TableCell className='cell-in-sticky border-l' padding='none' component={isHead} align='left' sx={{ minWidth: '300px', width: '300px', backgroundColor: isTotal ? "" : "#ffffff !important" }}>{itemRow.sSectionName}</TableCell>
                                        </TableCell>
                                        {
                                            itemRow.lstExpenseMonth.map((keyRow, indexMonth) => {
                                                let keyCellInput = keyCellTable + "_" + keyRow.nOrder;
                                                return (
                                                    <>
                                                        <TableCell
                                                            key={keyCellInput}
                                                            padding='none'
                                                            align='right'
                                                            component={isHead}
                                                            sx={{
                                                                textAlign: "right !important"
                                                            }}
                                                        >
                                                            {keyRow.value ? formatNumber(keyRow.value, 2) : ""}
                                                        </TableCell>

                                                        {
                                                            [2, 5, 8, 11].includes(indexMonth) ?
                                                                <TableCell
                                                                    key={keyCellInput}
                                                                    padding='none'
                                                                    align='right'
                                                                    component={isHead}
                                                                    sx={{
                                                                        textAlign: "right !important"
                                                                    }}
                                                                >
                                                                    {itemRow["nQ" + calIndexOld(indexMonth)] ? formatNumber(itemRow["nQ" + calIndexOld(indexMonth)], 2) : ""}

                                                                </TableCell>
                                                                :
                                                                null
                                                        }
                                                        {
                                                            [11].includes(indexMonth) ?
                                                                <TableCell
                                                                    padding='none'
                                                                    align='right'
                                                                    component={isHead}
                                                                    sx={{
                                                                        textAlign: "right !important"
                                                                    }}
                                                                >
                                                                    {itemRow.nTotal ? formatNumber(itemRow.nTotal, 2) : ""}
                                                                </TableCell>
                                                                :
                                                                null
                                                        }
                                                    </>
                                                )
                                            })
                                        }
                                    </TableRow>
                                )
                            })
                        }
                    </TableBody>
                </Table>
            </TableContainer>
        </AccordionPanel>
    )
}

export default TableExpenseSummary